import { PatientListDto } from '@lmt/shared-types';
import { CardData } from '@lmt/unicorn-shared/app/components/card-reader/components/CardReaderHandler';
import { PatientDataItem } from '@lmt/unicorn-shared/app/components/card-reader/components/PatientDataItem';
import {
  Button,
  ButtonColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import globalStyles from '@lmt/unicorn-shared/app/components/global-forms/Content.module.scss';
import { FormComponentProps } from '@lmt/unicorn-shared/app/components/global-forms/GlobalForms.types';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { useEventCallback } from '@mui/material';
import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';
import styles from './SelectPatientToUpdate.module.scss';

type Props = {
  cardData: CardData;
  patients: PatientListDto[];
};
export const SelectPatientToUpdate: FC<Props & FormComponentProps> = (
  props,
) => {
  const { formType, formId, tryCompleteForm, cardData, patients } = props;

  const i18n = useScopedTranslation(
    'merge_assistant.select_patient_for_update',
  );
  const [selectedPatientId, setSelectedPatientId] = useState<number | null>(
    null,
  );

  const onCreateNewPatient = useEventCallback(async () => {
    await tryCompleteForm(formType, formId, async () => -1);
  });

  const selectPatient = useEventCallback(async () => {
    if (!selectedPatientId) {
      return undefined;
    }
    await tryCompleteForm(formType, formId, async () => selectedPatientId);
  });

  useEffect(function selectFirstPatientAsDefault() {
    if (patients.length) {
      setSelectedPatientId(patients[0].id);
    }
  }, []);

  return (
    <div className={styles.formContainer}>
      <div className={styles.formContent}>
        <div
          className={styles.column}
          data-test-id="insurance-card-information-border"
        >
          <div className={styles.header} data-test-id="card-data-title">
            {i18n.t('card_data_title')}
          </div>
          <PatientDataItem cardData={cardData} isSelected={false} />
        </div>
        <div className={styles.verticalDivider} />
        <div className={clsx(styles.column, styles.matchesColumn)}>
          <div className={styles.header} data-test-id="found-patients-title">
            {i18n.t('found_patients_title')}
          </div>
          <div
            className={styles.gridContainer}
            data-test-id="matches-found-area"
          >
            {patients.map((patient, index) => (
              <PatientDataItem
                key={patient.id}
                patientId={patient.id}
                isSelected={selectedPatientId == patient.id}
                selectPatient={setSelectedPatientId}
              />
            ))}
          </div>
        </div>
      </div>
      <div className={globalStyles.submitContainer}>
        <div className={styles.controls}>
          <Button
            color={ButtonColor.Primary}
            title={i18n.t('buttons.create_new_patient')}
            onClick={onCreateNewPatient}
          />
          <Button
            className={globalStyles.submit}
            title={i18n.t('buttons.select_patient')}
            onClick={selectPatient}
            disabled={!selectedPatientId}
          />
        </div>
      </div>
    </div>
  );
};
